export default __webpack_public_path__ + "static/media/logo4.4c6a7a39.png";